import { render, staticRenderFns } from "./GridRdia.vue?vue&type=template&id=4c255a4e&scoped=true&"
import script from "./GridRdia.vue?vue&type=script&lang=ts&"
export * from "./GridRdia.vue?vue&type=script&lang=ts&"
import style0 from "./GridRdia.vue?vue&type=style&index=0&id=4c255a4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c255a4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4c255a4e', component.options)
    } else {
      api.reload('4c255a4e', component.options)
    }
    module.hot.accept("./GridRdia.vue?vue&type=template&id=4c255a4e&scoped=true&", function () {
      api.rerender('4c255a4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/reusable/Grid/GridRdia.vue"
export default component.exports